import * as React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import BorderedButton from '../../../components/BorderedButton';

interface MobileProps {
  mobile?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${themes.colors.KBLightBlueGrey};
  padding: 24px;
  max-width: 260px;
  margin-left: 20px;
  ${({ mobile }: MobileProps) => `
      flex-direction: ${mobile ? 'row' : 'column'};
      margin-left: 0px;
  `}
`;

const Text = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${themes.colors.KBNight};
  ${({ mobile }: MobileProps) => `
      margin-bottom: ${mobile ? '0px' : '18px'};
      margin-right: ${mobile ? '5px' : '0px'};
  `}
`;

type Props = {
  mobileLayout?: boolean;
  onClick: () => void;
};

const SkipToSignUpCTA = (props: Props) => {
  return (
    <Container mobile={props.mobileLayout}>
      <Text mobile={props.mobileLayout}>Create an account and book later?</Text>
      <BorderedButton text={'SIGN UP'} onClick={props.onClick} />
    </Container>
  );
};

export default SkipToSignUpCTA;
